import { Fragment, Slice } from "prosemirror-model";
import { Plugin } from "prosemirror-state";
import { normalizeLink } from "./utils";
const HTTP_LINK_REGEX = /(https?:\/\/)?(www\.)?[\p{L}\p{N}#%+.:=@~-]{2,256}\.[a-z]{2,6}\b([()\p{L}\p{N}#%&+./:=?@~-]*)/giu;
export function linkifyPasteRule() {
    return new Plugin({
        props: {
            transformPasted: (slice) => {
                return new Slice(linkify(slice.content), slice.openStart, slice.openEnd);
            },
        },
    });
}
function hasLinkMark(node) {
    return node.marks.some((mark) => mark.type.name === "link");
}
function linkify(fragment) {
    const linkified = [];
    fragment.forEach((child) => {
        if (child.isText && hasLinkMark(child)) {
            // add to linkified directly and stop processing
            linkified.push(child);
            return;
        }
        if (child.isText) {
            const text = child.text;
            let pos = 0;
            const linkMark = child.type.schema.marks.link;
            let match = HTTP_LINK_REGEX.exec(text);
            while (match) {
                const start = match.index;
                const end = start + match[0].length;
                // simply copy across the text from before the match
                if (start > 0) {
                    linkified.push(child.cut(pos, start));
                }
                const urlText = text.slice(start, end);
                linkified.push(child
                    .cut(start, end)
                    .mark(linkMark
                    .create({ href: normalizeLink(urlText) })
                    .addToSet(child.marks)));
                pos = end;
                match = HTTP_LINK_REGEX.exec(text);
            }
            // copy over whatever is left
            if (pos < text.length) {
                linkified.push(child.cut(pos));
            }
        }
        else {
            linkified.push(child.copy(linkify(child.content)));
        }
    });
    return Fragment.fromArray(linkified);
}
